import { Component, OnInit } from "@angular/core";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { CoreService } from "app/core/core.service";
import { StorageService } from "app/shared/services/storage.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-list-message",
  templateUrl: "./list-message.component.html",
  styleUrls: ["./list-message.component.scss"],
})
export class ListMessageComponent implements OnInit {
  param: any = {};
  private subscription: Subscription;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    private utilService: UtilService,
  ) {}

  ngOnInit() {
    this.subscription = this.coreService.updateRequest$.subscribe(() => {
      this.param = this.getParam();
    });
    this.param = this.getParam();
  }

  getParam(): any {
    const currentCount = this.utilService.getCurrentGeojsonCount(
      this.storageService.getGeoJsonRequest(),
    );
    const totalCount = this.utilService.getGeojsonCount(
      this.storageService.getGeoJsonRequest(),
    );
    return { valueStart: currentCount, valueEnd: totalCount };
  }
}
